import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import {
  AuthorizationService,
  COMMONS_ENVIRONMENT,
  ConfigLoader,
  DefaultConfigLoader,
  ECHARTS_THEME,
  EnvironmentConfigLoader,
  HttpClientLoaderTranslation,
  OAuthInterceptor,
  ServerSettingsService,
  SettingsService,
  W3hostnameInterceptor,
} from '@infodata-group/inf-commons';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { PieChart } from 'echarts/charts';
import { LegendComponent, TooltipComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { provideEchartsCore } from 'ngx-echarts';
import { CustomAuthorizationService } from '../service/custom-authorization.service';
import { environment } from '../../environments/environment';

echarts.use([CanvasRenderer, LegendComponent, PieChart, TooltipComponent]);

export const commonsProvidersFrom = [];

export const commonsProviders = [
  ...provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpClientLoaderTranslation,
      deps: [HttpClient],
    },
  }),
  { provide: COMMONS_ENVIRONMENT, useValue: environment },
  { provide: ConfigLoader, useClass: EnvironmentConfigLoader },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: W3hostnameInterceptor,
    multi: true,
  },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
  { provide: SettingsService, useClass: ServerSettingsService },
  { provide: AuthorizationService, useClass: CustomAuthorizationService },
  provideEchartsCore({ echarts, theme: ECHARTS_THEME }),
];
